"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.uninstallCallback = exports.installCallback = exports.defaultCallback = void 0;
var web_base_1 = require("@tencent/web-base");
var enum_1 = require("../../enum");
var download_1 = require("./download");
var trigger_launch_1 = require("./trigger-launch");
var universal_link_1 = require("./universal-link");
var defaultCallback = function (defaultCallbackProps) {
    var type = defaultCallbackProps.type, duration = defaultCallbackProps.duration, meetingCode = defaultCallbackProps.meetingCode, meetingState = defaultCallbackProps.meetingState, meetingType = defaultCallbackProps.meetingType, joinToken = defaultCallbackProps.joinToken, initLaunchRes = defaultCallbackProps.initLaunchRes, showDetail = defaultCallbackProps.showDetail, uninstallCb = defaultCallbackProps.uninstallCb, customScheme = defaultCallbackProps.customScheme, meetingId = defaultCallbackProps.meetingId, showDownload = defaultCallbackProps.showDownload, beaconReport = defaultCallbackProps.beaconReport, wxLaunchFailedCallback = defaultCallbackProps.wxLaunchFailedCallback, http = defaultCallbackProps.http, aegis = defaultCallbackProps.aegis;
    (0, exports.installCallback)({
        type: type,
        duration: duration,
        meetingCode: meetingCode,
        meetingState: meetingState,
        meetingType: meetingType,
        joinToken: joinToken,
        initLaunchRes: initLaunchRes,
        showDetail: showDetail,
        uninstallCb: uninstallCb,
        customScheme: customScheme,
        meetingId: meetingId,
        showDownload: showDownload,
        beaconReport: beaconReport,
        wxLaunchFailedCallback: wxLaunchFailedCallback,
        http: http,
        aegis: aegis,
    });
    showDownload(type);
};
exports.defaultCallback = defaultCallback;
/**
 * 安装会议拉起会议app
 * @param type
 * @returns
 */
var installCallback = function (props) {
    var _a;
    var type = props.type, 
    // duration,
    meetingCode = props.meetingCode, meetingState = props.meetingState, meetingType = props.meetingType, joinToken = props.joinToken, initLaunchRes = props.initLaunchRes, showDetail = props.showDetail, uninstallCb = props.uninstallCb, customScheme = props.customScheme, meetingId = props.meetingId, showDownload = props.showDownload, beaconReport = props.beaconReport, wxLaunchFailedCallback = props.wxLaunchFailedCallback, queryLaunchTimeout = props.queryLaunchTimeout, http = props.http, aegis = props.aegis, _b = props.from, from = _b === void 0 ? '' : _b, rs = props.rs;
    // 移动端ios微信调用Universal link唤起app
    var isUseUniversalLink = !!(((_a = window.urlQueryFromSS) === null || _a === void 0 ? void 0 : _a.isUseUniversalLink) || (0, web_base_1.getRequest)('isUseUniversalLink'));
    if (isUseUniversalLink
        && type === enum_1.EnumLaunchType.MeetingCode
        && (0, web_base_1.isIOS)()
        && (0, web_base_1.isWeChat)()
        && (0, web_base_1.isMobile)()) {
        var launchMode = Number((0, web_base_1.getRequest)('launch-mode') || enum_1.EnumLaunchMode.NotValid);
        var paths = window.location.pathname.split('/');
        var shortid = paths[2];
        if (!(meetingType === enum_1.EnumMeetingType.SpeciallyInvitedMeeting && launchMode === enum_1.EnumLaunchMode.QrCode)
            && shortid) {
            // beaconReport('meetingdetail_ulinklaunchapp_null_launchapp_null_null_launch', {
            //   arouse_purpose: 0,
            //   is_new_link: 0,
            // });
            var ulink = "".concat((0, universal_link_1.getUlinkPath)(true), "/").concat(shortid, "?rs=").concat(rs);
            window.location.href = ulink;
            return;
        }
    }
    // beaconReport('click_join_button_on_detail_page', {
    //   meeting_code: meetingCode,
    //   meeting_state: meetingState,
    //   user_agent: navigator.userAgent,
    //   is_launching_app: 1,
    //   experiment_id: getBeaconReportExperimentId(),
    //   gap_time: duration,
    //   is_pmi: getRequest('isPmi') ? 1 : 0, // 是否是PMI会议，1：是
    // });
    (0, trigger_launch_1.onClickLaunchApp)({
        type: type,
        meetingCode: meetingCode,
        meetingState: meetingState,
        meetingType: meetingType,
        joinToken: joinToken,
        initLaunchRes: initLaunchRes,
        showDetail: showDetail,
        defaultCb: uninstallCb,
        customScheme: customScheme,
        meetingId: meetingId,
        showDownload: showDownload,
        beaconReport: beaconReport,
        wxLaunchFailedCallback: wxLaunchFailedCallback,
        queryLaunchTimeout: queryLaunchTimeout,
        http: http,
        aegis: aegis,
        from: from,
        rs: rs,
    });
};
exports.installCallback = installCallback;
/**
 * 未安装进去下载引导页面
 * @param type
 */
var uninstallCallback = function (props) {
    var type = props.type, meetingCode = props.meetingCode, meetingState = props.meetingState, showDownload = props.showDownload, countryCode = props.countryCode, uninstallCb = props.uninstallCb;
    // 用户还没有查询到用户的 ip 地址对应的地区,则阻塞去查询结果: 不跳转到 “唤起腾讯会议 APP 页面”，但是会执行 schema 协议
    showDownload(type);
    // ios下自动唤起下载提示
    if ((0, web_base_1.isIOS)()) {
        (0, download_1.gotoDownload)(meetingCode, meetingState, countryCode, uninstallCb);
    }
    else {
        uninstallCb === null || uninstallCb === void 0 ? void 0 : uninstallCb();
    }
};
exports.uninstallCallback = uninstallCallback;
//# sourceMappingURL=launch-callback.js.map